import React, { useEffect, useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  LinearProgress,
} from '@mui/material';
import InventoryIcon from '@mui/icons-material/InventoryOutlined';
import AddIcon from '@mui/icons-material/Add';
import { useOrganization } from '../contexts/OrganizationContext';


const Assets = () => {
  const [value, setValue] = React.useState(0);
  const { selectedOrg, updateSelectedOrg } = useOrganization();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleAddAsset = () => {
    console.log('Add Asset button clicked!');
    // Add logic to handle adding a new asset
  };

  if (loading) {
    return (
      <Box
        sx={{
          width: '100%',
          // padding: '16px',
          backgroundColor: '#f9f9f9',
        }}
      >
        <Typography
          sx={{
            textAlign: 'center',
            //marginBottom: 2,
            color: '#2c3e50',
            fontWeight: 'bold',
          }}
        >
          Loading Assets...
        </Typography>
        <LinearProgress
          sx={{
            height: 4,
            borderRadius: 4,
            backgroundColor: '#e0e0e0', // Track color
            '& .MuiLinearProgress-bar': {
              borderRadius: 4,
              backgroundColor: '#3f51b5', // Bar color
            },
          }}
        />
      </Box>
    );
  }

  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box sx={{ padding: 0 }}>

      {/* Organization Dropdown */}
      {/*
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexGrow: 1,
          marginLeft: '16px',
          marginBottom: '24px',
        }}
      >
        {loading ? (
          <Typography variant="body2" sx={{ color: '#ecf0f1' }}>
            Loading organizations...
          </Typography>
        ) : error ? (
          <Typography variant="body2" sx={{ color: 'red' }}>
            {error}
          </Typography>
        ) : (
          <FormControl
            sx={{
              minWidth: 200,
              marginRight: 2,
              backgroundColor: '#2c3e50', // Background color
              borderRadius: '8px', // Rounded corners
              height: '36px', // Reduced height
              '& .MuiInputBase-root': {
                height: '36px', // Ensure dropdown matches the height
              },
            }}
          >
            <Select
              value={selectedOrg}
              onChange={handleOrgChange}
              sx={{
                color: '#ecf0f1', // Text color
                backgroundColor: '#2c3e50', // Dropdown background color
                borderRadius: '8px', // Rounded corners for the dropdown
                height: '100%', // Ensure height matches the container
                '& .MuiSelect-icon': { color: '#ecf0f1' }, // Icon color
              }}
            >
              {subscriptions.map((sub) => (
                <MenuItem
                  key={sub.subscriptionGuid}
                  value={sub.subscriptionGuid}
                  sx={{
                    color: '#2c3e50', // Darker text color for items
                    '&.Mui-selected': {
                      backgroundColor: '#e0f7fa', // Subtle background for selected item
                      color: '#2c3e50', // Maintain dark text for selected
                    },
                    '&:hover': {
                      backgroundColor: '#f5f5f5', // Hover effect for items
                    },
                  }}
                >
                  {sub.orgName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Box>
      */}

      {/* Header Row */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 6,
          paddingLeft: '16px',
          paddingRight: '16px',
        }}
      >
        {/* Left-aligned content */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <InventoryIcon sx={{ fontSize: '24px', color: '#2c3e50' }} />
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: '#2c3e50' }}
          >
            Assets
          </Typography>
        </Box>

        {/* Right-aligned button */}
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddAsset}
        >
          Add Asset
        </Button>
      </Box>

      {/* Horizontal Menu */}
      <Tabs value={value} onChange={handleChange} centered>
        <Tab label="Aircraft" />
        <Tab label="Batteries" />
      </Tabs>

      {/* Page Content */}
      <Box sx={{ padding: 3 }}>
        {value === 0 && <div>Aircraft Content</div>}
        {value === 1 && <div>Batteries Content</div>}
      </Box>
    </Box>
  );
};

export default Assets;